import { CustomerSite, Customer } from "@hydrologiq/gql-experience/graphql"
import Figure from "../generic/Figure"
import FigureContent from "../generic/FigureContent"
import { isCompactFigure } from "../generic/figureVariant"
import TrendIndicator from "../generic/TrendIndicator"

function CustomerEnergy({
  context,
  loading,
  error,
  isPlaceholder,
}: {
  context?: Customer | CustomerSite
  loading: boolean
  error: string | undefined
  isPlaceholder?: boolean
}) {
  const energy = context?.energy
  const hasValue = energy !== undefined && energy !== null
  const placeholder = isPlaceholder ?? !hasValue
  return (
    <Figure
      heading="Energy Generated"
      error={error ?? undefined}
      loading={loading}
      isPlaceholder={placeholder}
      compact={isCompactFigure("energy_flow")}
    >
      <FigureContent.SubText>yesterday</FigureContent.SubText>
      <FigureContent.Value>
        {hasValue ? `${Math.floor(energy * 100) / 100} kWh` : ""}
      </FigureContent.Value>
    </Figure>
  )
}

export default CustomerEnergy
